import React from 'react';
import { Link } from 'react-router-dom';
import { OPERATIONS_BESOIN, TYPES_BESOIN, formatBudget, labelFor, whatsappLink } from '../utils/besoins';

export default function BesoinCard({ besoin, actions }) {
  const wa = whatsappLink(besoin);
  const isLocation = besoin.operation === 'location';
  const typeLabel = labelFor(TYPES_BESOIN, besoin.typeBien);
  const auteur = besoin.proprietaire?.agence?.nomEntreprise || besoin.proprietaire?.nom || 'Membre Démarcheur';

  return (
    <article className={`besoin-card besoin-card-${besoin.operation}`}>
      <Link to={`/besoin/${besoin._id}`} className="besoin-card-cover" aria-label={`Voir : ${besoin.titre}`}>
        <span className="besoin-cover-pattern" aria-hidden="true" />
        <span className="besoin-cover-icon" aria-hidden="true">{isLocation ? '🔑' : '🏡'}</span>
        <span className="besoin-cover-copy">
          <small>Je recherche</small>
          <strong>{typeLabel} {isLocation ? 'à louer' : 'à acheter'}</strong>
          <span>📍 {besoin.ville || 'Guinée'}</span>
        </span>
        <span className={`besoin-operation besoin-operation-${besoin.operation}`}>
          {labelFor(OPERATIONS_BESOIN, besoin.operation)}
        </span>
      </Link>

      <div className="besoin-card-body">
        <div className="besoin-card-top">
          <span className="besoin-card-reference">Demande immobilière</span>
          <span className="besoin-date">{new Date(besoin.createdAt).toLocaleDateString('fr-FR')}</span>
        </div>
        <h2><Link to={`/besoin/${besoin._id}`}>{besoin.titre}</Link></h2>
        <div className="besoin-localisation">📍 {[besoin.quartiers, besoin.commune, besoin.ville].filter(Boolean).join(', ')}</div>
        <div className="besoin-facts">
          <span>{typeLabel}</span>
          {besoin.nbChambresMin ? <span>{besoin.nbChambresMin}+ chambres</span> : null}
          {besoin.surfaceMin ? <span>{besoin.surfaceMin} m² minimum</span> : null}
        </div>
        <p className="besoin-budget">{formatBudget(besoin)}</p>
        <p className="besoin-description">{besoin.description}</p>
        <div className="besoin-author">
          <span className="besoin-author-avatar">{auteur[0].toUpperCase()}</span>
          <span>
            <small>Demande publiée par</small>
            <strong>{auteur}</strong>
            <small>{besoin.proprietaire?.role === 'agency' ? 'Agence immobilière' : 'Particulier'}</small>
            {besoin.proprietaire?.emailVerifie && <small className="besoin-email-verified">✓ Email vérifié</small>}
          </span>
        </div>
        <div className="besoin-card-actions">
          <Link to={`/besoin/${besoin._id}`} className="btn btn-secondary btn-sm">Voir la demande</Link>
          {wa && <a href={wa} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm">Répondre sur WhatsApp</a>}
        </div>
        {actions ? <div className="besoin-owner-actions">{actions}</div> : null}
      </div>
    </article>
  );
}
